import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
// import axios from "axios";
// import { Buffer } from "buffer";
import GoogleReviews from "../../components/GoogleReviews/GoogleReviews";
import LanguageSwitcher from "../../components/LanguageSwitcher/LanguageSwitcher";
import { useI18n } from "../../i18n/LanguageContext";
import "./IndexPage.css";

function IndexPage() {
  const { state = { success: false } } = useLocation();
  const navigate = useNavigate();
  const { t } = useI18n();
  // Los párrafos largos (sobre nosotros, chef) se guardan como lista de
  // párrafos; este helper garantiza que siempre iteramos sobre un array.
  const paragraphs = (value) => (Array.isArray(value) ? value : [value]);
  const [animated1, setAnimated1] = useState(false);
  const [animated2, setAnimated2] = useState(false);
  const [animated3, setAnimated3] = useState(false);
  const [animated4, setAnimated4] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [mosaicVideos, setMosaicVideos] = useState([]);


  const closeModal = () => {
    setShowModal(false);
  };
  const className1 = animated1 ? "animated1" : "";
  const className2 = animated2 ? "animated2" : "";
  const className3 = animated3 ? "animated3" : "";
  const className4 = animated4 ? "animated4" : "";

  useEffect(() => {
    setTimeout(() => {
      setAnimated1(true);
      setAnimated2(true);
      setAnimated3(true);
      setAnimated4(true);
    }, 2500);
    window.scrollTo(0, 0);
  }, []);

  // Popup de portada: solo se muestra si la clienta no lo ha eliminado desde el
  // panel (/img/popup.json -> {"enabled": false}). Por defecto se muestra.
  useEffect(() => {
    fetch("/img/popup.json?t=" + Date.now(), { cache: "no-store" })
      .then((r) => (r.ok ? r.json() : null))
      .then((cfg) => {
        if (!cfg || cfg.enabled !== false) setShowModal(true);
      })
      .catch(() => setShowModal(true));
  }, []);

  // Vídeos del mosaico que la clienta añade desde el panel (/img/videos.json).
  // Se reproducen en bucle, sin sonido. Sin caché para que los cambios del
  // panel se vean al instante.
  useEffect(() => {
    fetch("/img/videos.json?t=" + Date.now(), { cache: "no-store" })
      .then((r) => (r.ok ? r.json() : []))
      .then((list) => setMosaicVideos(Array.isArray(list) ? list : []))
      .catch(() => setMosaicVideos([]));
  }, []);



  function handleLogout(event) {
    event.preventDefault();
    localStorage.removeItem("state");
    navigate("/");
  }

  // const [image, setImage] = useState(null);
  // const handleChange = (event) => {
  //   console.log(event.target.files);
  //   setImage(event.target.files[0]);
  // };
  // const handleSubmit = (event) => {
  //   event.preventDefault();

  //   const formData = new FormData();
  //   formData.append("image", image);
  //   axios
  //     .post(
  //       "https://suntaka-backend-production.up.railway.app/api/gallery",
  //       formData
  //     )
  //     .then(() => {
  //       window.location.reload();
  //       console.log("Image saved to database");
  //     })
  //     .catch((error) => {
  //       console.error(error);
  //     });
  // };

  // const [image2, setImage2] = useState(null);
  // const handleChange2 = (event) => {
  //   console.log(event.target.files);
  //   setImage2(event.target.files[0]);
  // };
  // const handleSubmit2 = (event) => {
  //   event.preventDefault();

  //   const formData = new FormData();
  //   formData.append("image2", image2);
  //   axios
  //     .post(
  //       "https://suntaka-backend-production.up.railway.app/api/images",
  //       formData
  //     )
  //     .then(() => {
  //       window.location.reload();
  //       console.log("Image saved to database");
  //     })
  //     .catch((error) => {
  //       console.error(error);
  //     });
  // };

  // const [image3, setImage3] = useState(null);
  // const handleChange3 = (event) => {
  //   console.log(event.target.files);
  //   setImage3(event.target.files[0]);
  // };
  // const handleSubmit3 = (event) => {
  //   event.preventDefault();

  //   const formData = new FormData();
  //   formData.append("image3", image3);
  //   axios
  //     .post(
  //       "https://suntaka-backend-production.up.railway.app/api/pics",
  //       formData
  //     )
  //     .then(() => {
  //       window.location.reload();
  //       console.log("Image saved to database");
  //     })
  //     .catch((error) => {
  //       console.error(error);
  //     });
  // };

  // const [gallery, setGallery] = useState([]);

  // useEffect(() => {
  //   fetch("https://suntaka-backend-production.up.railway.app/api/galleryImage")
  //     .then((x) => x.json())
  //     .then((y) => y.data)
  //     .then((allGallery) => setGallery(allGallery));
  // }, []);

  // const [images, setImagenes] = useState([]);

  // useEffect(() => {
  //   fetch("https://suntaka-backend-production.up.railway.app/api/imagesImage")
  //     .then((x) => x.json())
  //     .then((y) => y.data)
  //     .then((allImagen) => setImagenes(allImagen));
  // }, []);

  // const [pics, setPics] = useState([]);

  // useEffect(() => {
  //   fetch("https://suntaka-backend-production.up.railway.app/api/picsImage")
  //     .then((x) => x.json())
  //     .then((y) => y.data)
  //     .then((allPics) => setPics(allPics));
  // }, []);

  // const handleDelete = (id) => {
  //   const requestInit = {
  //     method: "DELETE",
  //   };
  //   fetch(
  //     "https://suntaka-backend-production.up.railway.app/api/gallerydelete/" + id,
  //     requestInit
  //   ).then((res) => {
  //     if (res.ok) {
  //       window.location.reload();
  //     } else {
  //       console.log("Error al eliminar");
  //     }
  //   });
  // };

  // const handleDelete2 = (id) => {
  //   const requestInit = {
  //     method: "DELETE",
  //   };
  //   fetch(
  //     "https://suntaka-backend-production.up.railway.app/api/imagesdelete/" + id,
  //     requestInit
  //   ).then((res) => {
  //     if (res.ok) {
  //       window.location.reload();
  //     } else {
  //       console.log("Error al eliminar");
  //     }
  //   });
  // };

  // const handleDelete3 = (id) => {
  //   const requestInit = {
  //     method: "DELETE",
  //   };
  //   fetch(
  //     "https://suntaka-backend-production.up.railway.app/api/picsdelete/" + id,
  //     requestInit
  //   ).then((res) => {
  //     if (res.ok) {
  //       window.location.reload();
  //     } else {
  //       console.log("Error al eliminar");
  //     }
  //   });
  // };

  return (
    <div>
      {showModal ? (
        <div className="modal">
          <div className="modal-content">
            <span className="close" onClick={closeModal}>
              X
            </span>
            
            <img loading="lazy" decoding="async" width="798" height="1100"
              className="popup"
              src="img/newpopup.webp"
              alt="Sun Taka busca camarero/a en Barcelona: incorporación inmediata, buen ambiente de trabajo y buenas condiciones. Envía tu CV a suntakabarcelona@gmail.com"
            />
          </div>
        </div>
      ) : null}
      <header>
        <LanguageSwitcher />
        <div className="presentation"></div>

        {state === null || !state.success || state.success === false ? (
          <p></p>
        ) : (
          <ul className="admin">
            <li>
              <a className="labeladmin2" href="/" onClick={handleLogout}>
                Desconectarse
              </a>
              <br></br>
              <br></br>
              <br></br>
              <br></br>
            </li>
          </ul>
        )}
        <div>
          <img
            className="logo2"
            src="img/logo.gif"
            alt="Sun Taka, restaurante japonés izakaya en Barcelona"
            width="1300"
            height="1082"
          />
          <h1 className="sr-only">{t("hero.h1")}</h1>

          {className1 ? (
            <>
              <div className="btn-flex-reservas">
                <a href="#reservation" className={className3}>
                  {t("nav.reserve")}
                </a>
              </div>
              <div className="btn-flex">
                <a href="#aboutus" className={className1}>
                  {t("nav.about")}
                </a>

                <a href="#card" className={className2}>
                  {t("nav.menu")}
                </a>

                <a href="#contact" className={className4}>
                  {t("nav.contact")}
                </a>
              </div>
              <div className="btn-flex-trabaja">
                <a
                  href="mailto:suntakabarcelona@gmail.com?subject=CV%20-%20Trabaja%20con%20nosotros%20Suntaka"
                  className={`${className3} btn-trabaja`}
                >
                  {t("nav.work")}
                </a>
              </div>
            </>
          ) : (
            <>
              <div className="btn-delay"></div>
            </>
          )}
        </div>
      </header>
      <h2 id="aboutus" className="titles about-us">
        {t("about.title")}
      </h2>
      <div className="container-aboutus1">
        {/* <div className="about-us-left">
          <img loading="lazy" decoding="async" width="566" height="788" className="suntaka" src="img/gal6.webp" alt="Cocina en vivo en la barra de Sun Taka, izakaya japonesa en Barcelona" />
          <img loading="lazy" decoding="async" width="566" height="788" className="suntaka2" src="img/gal6.webp" alt="Cocina en vivo en la barra de Sun Taka, izakaya japonesa en Barcelona" />
        </div> */}
        <div className="about-us-left">
          <div className="image-suntaka-1">
            <img loading="lazy" decoding="async" width="566" height="788"
              className="suntaka"
              src="img/gal6.webp"
              alt="Cocina en vivo en la barra de Sun Taka, izakaya japonesa en Barcelona"
            />
          </div>
          <div className="image-suntaka-2">
            <img loading="lazy" decoding="async" width="517" height="774"
              className="suntaka"
              src="img/carrusel4.webp"
              alt="Cocina en vivo en la barra de Sun Taka, izakaya japonesa en Barcelona"
            />
          </div>
        </div>
        <div className="about-us-right">
          <p className="aboutus-text">
            {paragraphs(t("about.body")).map((para, i) => (
              <React.Fragment key={i}>
                {i > 0 && (
                  <>
                    <br></br>
                    <br></br>
                  </>
                )}
                {para}
              </React.Fragment>
            ))}
          </p>
        </div>
      </div>

      <div className="barrido"></div>
      <h2 className="titles about-us2">{t("chef.title")}</h2>
      <div className="container-aboutus2">
        <div className="about-us-left2">
          <p className="aboutus-text">
            {paragraphs(t("chef.body")).map((para, i) => (
              <React.Fragment key={i}>
                {i > 0 && (
                  <>
                    <br></br>
                    <br></br>
                  </>
                )}
                {para}
              </React.Fragment>
            ))}
          </p>
        </div>
        <div className="about-us-right2">
          <div className="image-chef-1">
            <img loading="lazy" decoding="async" width="683" height="1024" src="img/kawata-mitsutaka3.webp" alt="Mitsutaka Kawata, chef de Sun Taka, en la barra de sushi" />
          </div>
          <div className="image-chef-2">
            <img loading="lazy" decoding="async" width="683" height="1024" src="img/elchef.webp" alt="El chef Taka preparando cocina japonesa tradicional en Sun Taka Barcelona" />
          </div>
          <div className="image-chef-3">
            <img loading="lazy" decoding="async" width="720" height="1280" src="img/elchef2.webp" alt="Mitsutaka Kawata, chef japonés de Osaka del restaurante izakaya Sun Taka en Barcelona" />
          </div>
        </div>
      </div>

      <div className="barrido1"></div>
      <div className="container-gallery">
        <img loading="lazy" decoding="async" width="960" height="1280" className="image" src="img/1.webp" alt="Sushi y nigiri de pescado fresco en Sun Taka, Barcelona" />
        <img loading="lazy" decoding="async" width="720" height="1280" className="image" src="img/2.webp" alt="Sashimi de pescado de temporada — Sun Taka, izakaya en Barcelona" />
        <img loading="lazy" decoding="async" width="960" height="1280" className="image" src="img/3.webp" alt="Plato de la carta japonesa de Sun Taka, Eixample (Barcelona)" />
        <img loading="lazy" decoding="async" width="853" height="1280" className="image" src="img/4.webp" alt="Especialidad de wagyu A5 en Sun Taka, restaurante japonés en Barcelona" />
        <img loading="lazy" decoding="async" width="1280" height="853" className="image" src="img/5.webp" alt="Cocina japonesa de autor del chef Taka en Sun Taka, Barcelona" />
        <img loading="lazy" decoding="async" width="826" height="1100" className="image" src="img/5.2.webp" alt="Marisco fresco preparado al estilo japonés en Sun Taka, Barcelona" />
      </div>
      <div className="container-gallery2">
        <img loading="lazy" decoding="async" width="960" height="1280" className="image" src="img/6.1.webp" alt="Plato de sushi de Sun Taka, restaurante izakaya en Barcelona" />
        <img loading="lazy" decoding="async" width="626" height="1100" className="image" src="img/7.1.webp" alt="Tataki y brasa japonesa en Sun Taka, Barcelona" />
        <img loading="lazy" decoding="async" width="720" height="1280" className="image" src="img/8.webp" alt="Detalle de un plato japonés de la carta de Sun Taka, Barcelona" />
        <img loading="lazy" decoding="async" width="563" height="1000" className="image" src="img/9.webp" alt="Ambiente de la izakaya Sun Taka en el Eixample, Barcelona" />
        <img loading="lazy" decoding="async" width="1131" height="1280" className="image" src="img/10.webp" alt="Sushi y nigiri de pescado fresco en Sun Taka, Barcelona" />
        <img loading="lazy" decoding="async" width="821" height="1100"
      
          className="image"
          src="img/10.1.webp"
          alt="Sashimi de pescado de temporada — Sun Taka, izakaya en Barcelona"
        />
        <img loading="lazy" decoding="async" width="948" height="1200"
      
          className="image"
          src="img/10.2.webp"
          alt="Plato de la carta japonesa de Sun Taka, Eixample (Barcelona)"
        />
      </div>
      <div className="container-gallery2">
        <img loading="lazy" decoding="async" width="619" height="1100" className="image" src="img/11.1.webp" alt="Especialidad de wagyu A5 en Sun Taka, restaurante japonés en Barcelona" />
        <img loading="lazy" decoding="async" width="912" height="1280" className="image" src="img/12.webp" alt="Cocina japonesa de autor del chef Taka en Sun Taka, Barcelona" />
        <img loading="lazy" decoding="async" width="563" height="1000" className="image" src="img/13.webp" alt="Marisco fresco preparado al estilo japonés en Sun Taka, Barcelona" />
        <img loading="lazy" decoding="async" width="667" height="1000" className="image" src="img/14.webp" alt="Plato de sushi de Sun Taka, restaurante izakaya en Barcelona" />
        <img loading="lazy" decoding="async" width="960" height="1280" className="image" src="img/15.webp" alt="Tataki y brasa japonesa en Sun Taka, Barcelona" />
        <img loading="lazy" decoding="async" width="1280" height="960" className="image" src="img/16.webp" alt="Detalle de un plato japonés de la carta de Sun Taka, Barcelona" />
      </div>

      {mosaicVideos.length > 0 && (
        <div className="container-gallery2">
          {mosaicVideos.map((file, i) => (
            <video
              key={i}
              className="image mosaic-video"
              src={`/img/${file}`}
              autoPlay
              muted
              loop
              playsInline
              preload="metadata"
              aria-label="Vídeo del restaurante Sun Taka, Barcelona"
            />
          ))}
        </div>
      )}

      {/* <div className="container-gallery">
        {gallery &&
          gallery.map((gallery) => {
            return (
              <div key={gallery.id}>
                <div>
                  <img
                    className="image"
                    src={`data:image/jpeg;base64,${Buffer.from(
                      gallery.data,
                      "binary"
                    ).toString()}`}
                    alt={`Imagen del ordenador ${gallery.nombre}`}
                  />
                  {state === null ||
                  state.user.usuario === null ||
                  !state.user ? (
                    <p></p>
                  ) : state.user.usuario === "suntaka" ? (
                    <div>
                      <p
                        className="btn"
                        onClick={() => handleDelete(gallery.id)}
                      >
                        Eliminar
                      </p>

                      <br></br>
                    </div>
                  ) : null}
                </div>
              </div>
            );
          })}
        {state === null || state.user.usuario === null || !state.user ? (
          <p></p>
        ) : state.user.usuario === "suntaka" ? (
          <form onSubmit={handleSubmit}>
            <br />
            <input
              className="labeladmin btn"
              type="file"
              onChange={handleChange}
            />
            <button className="btn" type="submit">
              Subir
            </button>
          </form>
        ) : null}
      </div>

      <div className="container-gallery2">
        {images &&
          images.map((images) => {
            return (
              <div key={images.id}>
                <div>
                  <img
                    className="image"
                    src={`data:image/jpeg;base64,${Buffer.from(
                      images.data,
                      "binary"
                    ).toString()}`}
                    alt={`Imagen del ordenador ${images.nombre}`}
                  />
                  {state === null ||
                  state.user.usuario === null ||
                  !state.user ? (
                    <p></p>
                  ) : state.user.usuario === "suntaka" ? (
                    <div>
                      <p
                        className="btn"
                        onClick={() => handleDelete2(images.id)}
                      >
                        Eliminar
                      </p>

                      <br></br>
                    </div>
                  ) : null}
                </div>
              </div>
            );
          })}
        {state === null || state.user.usuario === null || !state.user ? (
          <p></p>
        ) : state.user.usuario === "suntaka" ? (
          <form onSubmit={handleSubmit2}>
            <br />
            <input
              className="labeladmin btn"
              type="file"
              onChange={handleChange2}
            />
            <button className="btn" type="submit">
              Subir
            </button>
          </form>
        ) : null}
      </div>

      <div className="container-gallery2">
        {pics &&
          pics.map((pic) => {
            return (
              <div key={pic.id}>
                <div>
                  <img
                    className="image"
                    src={`data:image/jpeg;base64,${Buffer.from(
                      pic.data,
                      "binary"
                    ).toString()}`}
                    alt={`Imagen del ordenador ${pic.nombre}`}
                  />
                  {state === null ||
                  state.user.usuario === null ||
                  !state.user ? (
                    <p></p>
                  ) : state.user.usuario === "suntaka" ? (
                    <div>
                      <p className="btn" onClick={() => handleDelete3(pic.id)}>
                        Eliminar
                      </p>

                      <br></br>
                    </div>
                  ) : null}
                </div>
              </div>
            );
          })}
        {state === null || state.user.usuario === null || !state.user ? (
          <p></p>
        ) : state.user.usuario === "suntaka" ? (
          <form onSubmit={handleSubmit3}>
            <br />
            <input
              className="labeladmin btn"
              type="file"
              onChange={handleChange3}
            />
            <button className="btn" type="submit">
              Subir
            </button>
          </form>
        ) : null}
      </div> */}

      <h2 id="card" className="titles card">
        {t("menu.title")}
      </h2>
      <p className="frase">
        <i className="cita">{t("menu.quote")}</i>
        <br></br>
        <br></br>
        <a
          className="citador"
          href="https://www.instagram.com/mitsutaka5638/"
          target="_blank"
          rel="noreferrer"
        >
          Mitsutaka Kawata
        </a>
      </p>

      <div className="container-father">
        <div className="container-btn">
        <a
  className="btn3"
  href="/card"
  rel="noopener noreferrer"
>
            <p className="btn-text">{t("menu.card")}</p>
            <img loading="lazy" decoding="async" width="256" height="256"
              className="carta-img"
              src="img/sugerencias_icono.webp"
              alt="Ver la carta de Sun Taka, restaurante japonés en Barcelona"
            />
          </a>
          {state === null || state.user.usuario === null || !state.user ? (
            <p></p>
          ) : state.user.usuario === "suntaka" ? (
            <p
              className="btn btn-edit"
              onClick={() => navigate("/cardEdit", { state })}
            >
              ✏️ Editar carta
            </p>
          ) : null}

<a
  className="btn3"
  href="/sugested"
  rel="noopener noreferrer"
>
            <p className="btn-text">{t("menu.suggestions")}</p>
            <img loading="lazy" decoding="async" width="256" height="256"
              className="carta-img"
              src="img/la%20carta_icono.webp"
              alt="Sugerencias del chef de Sun Taka"
            />
          </a>
          {state === null || state.user.usuario === null || !state.user ? (
            <p></p>
          ) : state.user.usuario === "suntaka" ? (
            <p
              className="btn btn-edit"
              onClick={() => navigate("/sugestedEdit", { state })}
            >
              ✏️ Editar sugerencias
            </p>
          ) : null}

<a
  className="btn3"
  href="/desserts"
  rel="noopener noreferrer"
>
            <p className="btn-text">{t("menu.desserts")}</p>
            <img loading="lazy" decoding="async" width="256" height="256"
              className="carta-img"
              src="img/postres_icono.webp"
              alt="Carta de postres japoneses de Sun Taka"
            />
          </a>
          {state === null || state.user.usuario === null || !state.user ? (
            <p></p>
          ) : state.user.usuario === "suntaka" ? (
            <p
              className="btn btn-edit"
              onClick={() => navigate("/dessertsEdit", { state })}
            >
              ✏️ Editar Postres
            </p>
          ) : null}

<a
  className="btn3"
  href="/winesake"
  rel="noopener noreferrer"
>
  <p className="btn-text">{t("menu.cellar")}</p>
  <img loading="lazy" decoding="async" width="256" height="256"
    className="carta-img"
    src="img/bebida_icono.webp"
    alt="Bodega y vinos de Sun Taka"
  />
</a>
          {state === null || state.user.usuario === null || !state.user ? (
            <p></p>
          ) : state.user.usuario === "suntaka" ? (
            <p
              className="btn btn-edit"
              onClick={() => navigate("/winesakeEdit", { state })}
            >
              ✏️ Editar Bodega
            </p>
          ) : null}

<a
  className="btn3"
  href="/sake"
  rel="noopener noreferrer"
>
            <p className="btn-text">{t("menu.sake")}</p>
            <img loading="lazy" decoding="async" width="256" height="256"
              className="carta-img"
              src="img/sake_icono.webp"
              alt="Carta de sakes japoneses de Sun Taka"
            />
          </a>

<a
  className="btn3"
  href="/whisky"
  rel="noopener noreferrer"
>
            <p className="btn-text">{t("menu.whisky")}</p>
            <img loading="lazy" decoding="async" width="256" height="256"
              className="carta-img"
              src="img/wisky_icono.webp"
              alt="Carta de whisky japonés de Sun Taka"
            />
          </a>
        </div>
      </div>
      <div className="barrido2"></div>
      <div className="reservation-container">
        <h2 id="reservation" className="titles">
          {t("reservations.title")}
        </h2>
        <div className="reservation-text">
          <a href="tel:932502349">{t("reservations.callToReserve")}</a>
        </div>
        <br></br>
        <div className="reservation-text2">
          <a className="reservation-text-color" href="tel:932502349">
            932 50 23 49
          </a>
        </div>
        <div className="reservas-container">
          <a
            className="reservaonline"
            href=" https://module.lafourchette.com/es_ES/module/463365-22033 "
            target="_blank"
            rel="noreferrer"
          >
            {t("reservations.onlineReserve")}
          </a>
        </div>
      </div>
      <div className="barrido3"></div>
      <h2 id="review" className="titles">
        {t("reviews.title")}
      </h2>
      <GoogleReviews />
      <div className="reviews-cta">
        <a
          href="https://g.page/r/CYvght3fMoNlEB0/review"
          target="_blank"
          rel="noreferrer"
        >
          {t("reviews.cta")}
        </a>
      </div>

      <div className="abanico-line"></div>
      <img loading="lazy" decoding="async" width="1400" height="571" className="abanico" src="img/abanico2.webp" alt="abanico" />
      <footer id="contact">
        <div className="footer-container">
          <div className="footer-section1">
            <h2>{t("footer.contact")}</h2>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.google.es/maps/place/SUN+TAKA/@41.3974079,2.1635414,17z/data=!3m1!4b1!4m5!3m4!1s0x12a4a3eb0bb6f8db:0x658332dfdd86e08b!8m2!3d41.3974079!4d2.1657301?hl=es"
            >
              {t("footer.address")}
            </a>
            <br></br>
            <br></br>
            <a href="tel:932502349">{t("footer.phone")}</a>
            <br></br>
            <br></br>
            <a href="mailto:suntakabarcelona@gmail.com">
              {t("footer.email")}
            </a>
          </div>
          <div className="footer-section2">
            <h2>{t("footer.hours")}</h2>
            <p>{t("footer.days")}</p>
            <p>{t("footer.hoursDetail")}</p>
            <p>{t("footer.closed")}</p>
          </div>
        </div>
        <div className="footer-social">
          <a
            className="social-icon s-facebook"
            target="_blank"
            rel="noreferrer"
            aria-label="Facebook"
            href="https://www.facebook.com/SunTakabarcelona/"
          ></a>
          <a
            className="social-icon s-instagram"
            target="_blank"
            rel="noreferrer"
            aria-label="Instagram"
            href="https://www.instagram.com/suntaka.bcn/?igshid=YmMyMTA2M2Y%3D"
          ></a>
          <a
            className="social-icon s-tripadvisor"
            target="_blank"
            rel="noreferrer"
            aria-label="Tripadvisor"
            href="https://www.tripadvisor.es/Restaurant_Review-g187497-d15648197-Reviews-Sun_Taka-Barcelona_Catalonia.html"
          ></a>
          <a
            className="social-icon s-maps"
            target="_blank"
            rel="noreferrer"
            aria-label="Ubicación en Google Maps"
            href="https://www.google.es/maps/place/SUN+TAKA/@41.3974079,2.1635414,17z/data=!3m1!4b1!4m5!3m4!1s0x12a4a3eb0bb6f8db:0x658332dfdd86e08b!8m2!3d41.3974079!4d2.1657301?hl=es"
          ></a>
        </div>
        <div className="copyright">
          <p>{t("footer.copyright")}</p>
        </div>
      </footer>
    </div>
  );
}

export default IndexPage;
